import { createIcon } from "@chakra-ui/react";

const SpaceIcon = createIcon({
  displayName: "SpaceIcon",
  viewBox: "0 0 24 24",
  path: (
    <path
      d="M12.5201 18.1475L13.0738 14.7918H10.0201L9.46644 18.1475H8.24161L8.7953 14.7918H7L7.20134 13.5838H8.99664L9.5 10.5636H7.72148L7.90604 9.35558H9.68456L10.2383 5.99988H11.4631L10.9094 9.35558H13.9631L14.5168 5.99988H15.7416L15.1879 9.35558H17L16.7987 10.5636H15.0034L14.5 13.5838H16.2785L16.0772 14.7918H14.2987L13.745 18.1475H12.5201ZM10.2215 13.5838H13.2752L13.7785 10.5636H10.7248L10.2215 13.5838Z"
      fill="currentColor"
    />
  ),
});

export default SpaceIcon;
